// extracted by mini-css-extract-plugin
export default {"deliveryZonePageRoot":"deliveryZonePageRoot___EbIVl"};